module.exports = __webpack_public_path__ + "97221fb42a4c68f63ecaab345cb94abb.jpg";